import React from 'react';
import SubPage from '../SubPage';
import Cards from './Cards';
import D from './solData';
import { useLang } from '../../LanguageContext';
import useSite from '../../useSite';

const CRUMB = { ko: 'ML-CARE 솔루션', en: 'ML-CARE Solution' };

const T = (PATENTS) => ({
  title: { ko: '주요 기능', en: 'Key Features' },
  lede:  { ko: '현장의 돌봄을 바꾸는 ML-CARE 솔루션의 핵심 기능입니다.',
           en: 'The capabilities that change how care works on the ground.' },
  h2:    { ko: '돌봄의 질을 높이는 세 가지 핵심 기능', en: 'Three capabilities that raise the quality of care' },
  hi:    { ko: '서비스 특장점', en: 'Service Highlights' },
  note:  { ko: <>스마트 기저귀 관련 <strong>등록 특허 {PATENTS}건</strong>과 상표 <strong>ML-CARE(엠엘케어)</strong>를 보유하고 있습니다.</>,
           en: <>MEDILOGIS holds <strong>{PATENTS} registered patents</strong> related to the smart diaper, along with the <strong>ML-CARE</strong> trademark.</> },
});

function SolFeatures() {
  const { lang } = useLang();
  const cfg = useSite('/api/site/config', null);
  const T2 = T((cfg && cfg.patents && cfg.patents.ko) || 4);
  const [core, extra, highlights] = D.features;
  return (
    <SubPage crumb={CRUMB[lang]} title={T2.title[lang]} lede={T2.lede[lang]}>
      <div className="sp-label">KEY FEATURES</div>
      <h2>{T2.h2[lang]}</h2>
      <Cards items={core} cols={3} className="sp-mt" />
      <Cards items={extra} cols={2} className="sp-mt" />

      <div className="sp-note sp-mt-lg">{T2.note[lang]}</div>

      <div className="sp-label sp-mt-lg">HIGHLIGHTS</div>
      <h2>{T2.hi[lang]}</h2>
      <Cards items={highlights} cols={2} className="sp-mt" />
    </SubPage>
  );
}

export default SolFeatures;
